<template>
  <div id="toast-container">
    <transition-group mode="out-in" name="slideRight">
      <div v-for="(toast, i) in messages" :class="[toast.type, 'toast-outer']" :key="toast.guid">
        <header>
          <i :class="headerIcon(toast.type)"></i> {{ toast.type.toUpperCase() }}
        </header>
        <p v-text="toast.message"></p>
        <div class="close-toast" @click="remove(toast.guid)">
          <i class="fa fa-times fa-2x"></i>
        </div>
      </div>
    </transition-group>
  </div>
</template>
<script>
  import event from '../event'
  export default {
    name: 'Toast',
    data () {
      return {
        messages: [],
        count: 0
      }
    },
    methods: {
      add (toast) {
        const guid = typeof window.guid === 'function' ? window.guid() : this.count++
        this.messages.push({ ...toast, guid })
        // if (toast.type !== 'error' && toast.type !== 'warning') {
        setTimeout(() => {
          this.remove(guid)
        }, 5000)
        // }
      },
      remove (id) {
        let index = this.messages.findIndex(m => m.guid === id)
        if (index > -1) {
          this.messages.splice(index, 1)
        }
      },
      headerIcon (type) {
        let icon
        switch (type) {
          case 'error':
            icon = 'fa fa-times'
            break
          case 'warning':
            icon = 'fa fa-exclamation-circle'
            break
          case 'success':
            icon = 'fa fa-check'
            break
        }
        return icon
      }
    },
    created () {
      event.$on('toast', this.add)
    },
    beforeDestroy () {
      event.$off('toast', this.add)
    }
  }
</script>

<style>
  .error {
    background-color: #FFBABA;
    color: #D8000C;
  }
  .warning {
    background-color: #FEEFB3;
    color: #9F6000;
  }
  .success {
    background-color: #dff0d8;
    color: #3c763d;
  }
  #toast-container {
    position: fixed;
    top: 0px;
    right: 10px;
    display: flex;
    width: 300px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    z-index: 9999;
  }
  #toast-container span {
    width:100%;
  }
  #toast-container span div.toast-outer {
    margin: 5px;
    width: 100%;
    padding: 10px;
    transition: all 0.5s;
    position: relative;
  }
  #toast-container p {
    margin-top: 10px;
  }
  #toast-container .close-toast {
    position: absolute;
    top: 0;
    right: 3px;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/Toast.vue